// Select tool: pointer becomes a cursor; clicking blank space deselects, and
// clicking a node selects it (the per-node pointerdown handler in
// _helpers.attachInteractive does the actual selection).

export const select = {
  id: 'select',
  defaultProps: {},
  onPointerDown(engine, e) {
    if (e.target === engine.stage || e.target === engine.bgImage) {
      engine.deselect();
    }
  },
  onPointerMove() {},
  onPointerUp() {},
};
